import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';

import getRatio from '../../lib/getRatio';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

import Image from '../partials/Image';
import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/taxonomy-horizontal-card.module.css';

interface TaxonomyHorizontalCardProps extends Partial<TaxonomyBase> {
    theme?: CardTheme | LegacyCardTheme | null;
    size?: CardSize | null;
    ratio?: CardRatio | null;
    height?: number | null;
    placeholder?: boolean;
    withBorder?: boolean;
    className?: string | null;
}
function TaxonomyHorizontalCard({
    type = 'category',
    slug = null,
    label = null,
    image = null,
    ratio = null,
    height = 90,
    theme: providedTheme = null,
    size = null,
    placeholder = false,
    withBorder = false,
    className = null,
}: TaxonomyHorizontalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useUrlGenerator();
    const thumbnailRatio = getRatio(ratio, 5 / 4);
    const withoutThumbnail = theme === 'without-thumbnail' || theme === 'pill';
    return (
        <HorizontalCard
            presentation="taxonomy-horizontal"
            theme={theme || 'none'}
            size={size || 'default'}
            href={
                slug !== null
                    ? url(type, {
                          slug,
                      })
                    : null
            }
            thumbnail={
                !withoutThumbnail ? (
                    <Image
                        width={thumbnailRatio * height}
                        height={height}
                        media={image}
                        withPlaceholder={placeholder}
                        className={styles.thumbnail}
                    />
                ) : null
            }
            thumbnailRatio={thumbnailRatio}
            height={!withoutThumbnail ? height : null}
            className={classNames([
                styles.container,
                {
                    [styles.withBorder]: withBorder,
                },
                className,
            ])}
            innerClassName={styles.inner}
            thumbnailClassName={styles.thumbnailContainer}
        >
            <CardTitle tag="span" className={styles.title} placeholder={placeholder}>
                {label}
            </CardTitle>
        </HorizontalCard>
    );
}
export default TaxonomyHorizontalCard;
